var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { FIRE_FIREPLACE_AGE_OPTIONS } from '@shared/constants/fireDamageConstants';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
const claim = namespace('claim');
const qualification = namespace('qualification');
const contract = namespace('contract');
let FireFireplaceAgeQuestion = class FireFireplaceAgeQuestion extends QuestionComponent {
    updateClaim(fireFireplaceAge) {
        this.updateAndSaveFireDamageQualification({
            qualificationPayload: {
                fireFireplaceAge,
            },
            step: this.step,
        });
    }
    get answer() {
        if (!this.fireDamageQualification.fireFireplaceAge) {
            return null;
        }
        return FIRE_FIREPLACE_AGE_OPTIONS[this.fireDamageQualification.fireFireplaceAge]
            ? this.$tc(FIRE_FIREPLACE_AGE_OPTIONS[this.fireDamageQualification.fireFireplaceAge].answerTradKey, 0)
            : null;
    }
    get fireFireplaceAgeOptions() {
        return Object.values(FIRE_FIREPLACE_AGE_OPTIONS);
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], FireFireplaceAgeQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], FireFireplaceAgeQuestion.prototype, "fireDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], FireFireplaceAgeQuestion.prototype, "updateAndSaveFireDamageQualification", void 0);
__decorate([
    contract.State('selectedContract')
], FireFireplaceAgeQuestion.prototype, "selectedContract", void 0);
FireFireplaceAgeQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], FireFireplaceAgeQuestion);
export default FireFireplaceAgeQuestion;
